"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const rfid_tag_types_1 = require("./rfid-tag.types");
const initialState = {
    errorCode: 0,
    isError: false,
    isLoading: true,
    isSuccess: false,
    errorMessage: '',
    mutationMode: false,
};
const rfidTagReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [rfid_tag_types_1.rfidTagConfigTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { mutationMode, isSuccess, isLoading } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: isLoading, mutationMode: mutationMode, isSuccess: isSuccess === undefined ? state.isSuccess : isSuccess });
    },
    [rfid_tag_types_1.rfidTagConfigTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false, isSuccess: false });
    },
});
exports.default = rfidTagReducer;
